import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { SnackbarProvider } from 'notistack'
import { useEffect } from 'react'
import { Route, Routes, useNavigate } from 'react-router-dom'

import { createStorageConfig } from './api'
import { ApiBlockedBanner } from './components/ApiBlockedBanner/ApiBlockedBanner'
import { OfflineBanner } from './components/OfflineBanner/OfflineBanner'
import { useApiReachability, useNetworkStatus, useOperatorApi } from './hooks/'
import { Layout, Page } from './layouts'
import { theme } from './pages/karma.theme'

import 'dayjs/locale/de'

export const App = () => {
  const navigate = useNavigate()
  const { logout, getIdleLogout } = useOperatorApi()
  const { isOnline } = useNetworkStatus()
  const { isApiReachable, isChecking } = useApiReachability()

  useEffect(() => {
    const cleanup = getIdleLogout(
      () => {
        logout()
        navigate('/login-page', { replace: true })
      },
      12 * 60 * 60 * 1000
    )
    return cleanup
  }, [getIdleLogout, logout, navigate])

  useEffect(() => {
    createStorageConfig()
  }, [])

  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        autoHideDuration={5000}
        maxSnack={10}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'de'}>
          <CssBaseline />

          {!isOnline && <OfflineBanner />}
          {isOnline && !isChecking && !isApiReachable && <ApiBlockedBanner />}

          <Routes>
            <Route path={'/pages/*'} element={<Page />} />
            <Route path={'/*'} element={<Layout />} />
          </Routes>
        </LocalizationProvider>
      </SnackbarProvider>
    </ThemeProvider>
  )
}
